// Shown when a payment may already have been collected and is still being confirmed by
// the AU office. There is deliberately no Pay button here: the member must not pay again.
export function PaymentPending({ message }: { message: string }) {
  return (
    <div className="max-w-lg mx-auto mt-8 text-center">
      <div className="bg-warning/10 border border-warning/30 rounded-lg p-8">
        <h1 className="text-2xl font-heading font-bold text-text mb-3">Payment being confirmed</h1>
        <p className="text-text-light">{message}</p>
      </div>
    </div>
  )
}
